import { Component, Injector, AfterViewInit, inject, Input, ViewChild } from '@angular/core';
import { ABOUT_US, ADVOCATES, CANCEL, COMMON_MODULES, COMPREHENSIVE_SELECTION, CONTACT_US, EMPLOYERS, EMPLOYERS_QUOTATION, MARKETING_PRESELL_PAGE, PROFESSIONAL_BOOKED_APPOINTMENT, RESOURCES, ROUTES, SUCCESS, PHARMACY_LIST, PHARMACY_BRAND_DETAILS, APPOINTMENT_BOOKED_DETAIL, REQUEST_IMAGING_APPOINTMENT, REQUEST_SURGICAL_APPOINTMENT, VERIFY_PROFILE, PAYMENT, EINSTEIN, WHATA_BURGER, PARKER_HOSPITALITY, PERFECTPIZZAPIE, AQUORAL, JETS_PIZZA, CEHAS_ACCESS_ACCOUNT, CEHAS, FAZOLI, PRESTIGE, HUB_INTERNATIONAL, SSP, ACAWELLNESS, TRU, TRU_ACCESS_ACCOUNT,AMAC, ACA_CONTENT, ARS, REQ_CONSULTING_BASIC, REQ_CONSULTING_PLUS, IAC} from '@src/app/core/constants';
import { ImageboxOneModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-one/imagebox-one.module';
import { IMAGES_URL } from '@src/app/core/constants/system-list.constant';
import { Router } from '@angular/router';
import { TermsOfUseModalComponent } from '@src/app/core/shared/components/terms-of-use-modal/terms-of-use-modal.component';
import { PrivacyPolicyModalComponent } from '@src/app/core/shared/components/privacy-policy-modal/privacy-policy-modal.component';
import { SharedDataService } from '@src/app/core/services';
import { CoreClass } from '@src/app/core/base/core.class';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { employers_provider, providers } from '@src/app/core/constants';
import { Store } from '@ngxs/store';
import { AppModeState } from '@src/app/core/ngxs/actions/app-mode.state';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

declare var $: any;
// import * as $ from 'jquery';
@Component({
  selector: 'app-minienv-footer',
  standalone: true,
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [...COMMON_MODULES, ImageboxOneModule,TermsOfUseModalComponent],
})
export class MiniEnvFooterComponent extends CoreClass {
  public routes = ROUTES;
  showPciComplaint: boolean = true;
  showAicpaIcon: boolean = true;
  showHippaCompliance: boolean = true;
  hasWellnessMembership: boolean = false;
  // activesection: string | null = null;
  employers_provider: string = employers_provider;
  providers: string = providers;
  LinkedinLink: string | null = null;
  InstragramLink: string | null = null;
  FacebookLink: string | null = null;
  TwitterLink: string | null = null;
  readonly appSectionhiddenRoutes: string[] = [
    CANCEL,
    SUCCESS,
    ADVOCATES,
    EMPLOYERS,
    EMPLOYERS_QUOTATION,
    PROFESSIONAL_BOOKED_APPOINTMENT,
    ABOUT_US,
    CONTACT_US,
    MARKETING_PRESELL_PAGE,
    RESOURCES,
    COMPREHENSIVE_SELECTION,
    PHARMACY_LIST,
    PHARMACY_BRAND_DETAILS,
    APPOINTMENT_BOOKED_DETAIL,
    REQUEST_IMAGING_APPOINTMENT,
    REQUEST_SURGICAL_APPOINTMENT,
    VERIFY_PROFILE,
    PAYMENT,
    EINSTEIN,
    WHATA_BURGER,
    PARKER_HOSPITALITY,
    PERFECTPIZZAPIE,
    AQUORAL,
    JETS_PIZZA,
    CEHAS_ACCESS_ACCOUNT,
    CEHAS,
    FAZOLI,
    PRESTIGE,
    HUB_INTERNATIONAL,
    SSP, ACAWELLNESS,
    TRU,
    TRU_ACCESS_ACCOUNT,
    AMAC,
    ACA_CONTENT,
    REQ_CONSULTING_BASIC,
    REQ_CONSULTING_PLUS,
    ARS,
    IAC
  ];
  readonly appMaunehidesection: string[] = [
    EMPLOYERS_QUOTATION,
  ]
  readonly appMainSectionhiddenRoutes: string[] = [
    PHARMACY_LIST,
    PHARMACY_BRAND_DETAILS,
    REQUEST_IMAGING_APPOINTMENT,
    REQUEST_SURGICAL_APPOINTMENT,
    CANCEL,
    VERIFY_PROFILE,
    CEHAS_ACCESS_ACCOUNT,
    TRU_ACCESS_ACCOUNT
    // APPOINTMENT_BOOKED_DETAIL
  ];
  public route = inject(Router)
  facebookSvg!: SafeHtml;
  linkedInSvg!: SafeHtml;
  twitterSvg!: SafeHtml;
  @ViewChild(TermsOfUseModalComponent) termUseModalComp!: TermsOfUseModalComponent;
  @ViewChild(PrivacyPolicyModalComponent) privacyPolicyModalComp!: PrivacyPolicyModalComponent;

  constructor(
    protected injector: Injector,
    public override router: Router,
    private _route: ActivatedRoute,
    private store: Store,
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {
    super(injector);

    const config = this.store.selectSnapshot(AppModeState.envConfig);
    this.LinkedinLink = config?.linkedinLink || null;
    this.InstragramLink = config?.instagramUrl || null;
    this.FacebookLink = config?.facebookLink || null;
    this.TwitterLink = config?.twitterLink || null;

    this.showAicpaIcon = config?.hideAicpaIcon ? false : true;
    this.showHippaCompliance = config?.hideHippaCompliance ? false : true;
    this.showPciComplaint = config?.hidePciComplaint ? false : true;
  }

  ngOnInit() {
    this.formembership('membership');
    this.hasWellnessMembership = localStorage.getItem('hasWellnessMembership') === 'true';
    let storedData = localStorage.getItem('miniEnvConfig');
    let parsedData = JSON.parse(storedData || '{}');
    let name = parsedData.name;
    if (name === 'Aca wellness') {
      this.hasWellnessMembership = true;
    }
    this.http.get(this.sharedService.imagesUrl + 'icons/facebook-white.svg', { responseType: 'text' })
      .subscribe(svg => {
        svg = svg.replace(/fill="#784978"/g, 'fill="currentColor"');
        this.facebookSvg = this.sanitizer.bypassSecurityTrustHtml(svg);
      });
    this.http.get(this.sharedService.imagesUrl + 'icons/linkedin-white.svg', { responseType: 'text' })
      .subscribe(svg => {
        svg = svg.replace(/fill="#784978"/g, 'fill="currentColor"');
        this.linkedInSvg = this.sanitizer.bypassSecurityTrustHtml(svg);
      });
    this.http.get(this.sharedService.imagesUrl + 'icons/twitter-white.svg', { responseType: 'text' })
      .subscribe(svg => {
        svg = svg.replace(/fill="#784978"/g, 'fill="currentColor"');
        this.twitterSvg = this.sanitizer.bypassSecurityTrustHtml(svg);
      });
  }

  currentYear: number = new Date().getFullYear();

  ngAfterViewInit() {
  }
  // An empty link means this tenant has no app on that store.
  hasAppLinks: boolean = !!this.constantList.ANDROID_APP_LINK || !!this.constantList.IOS_APP_LINK;

  hideAppSection(): boolean {
    if (!this.hasAppLinks) {
      return true;
    }
    return this.appSectionhiddenRoutes.some(path => this.router.url.includes(path));
  }
  hideFooterMainSection(): boolean {
    return this.appMainSectionhiddenRoutes.some(path => this.router.url.includes(path));
  }
  hidemenue(): boolean {
    return this.appMaunehidesection.some(path => this.router.url.includes(path));

  }

  public setLanguage(event: any) {
    const ln = event?.target?.value?.toLowerCase();
    const lang = { code: ln };
    this.localStorageService.setDataInLocalStorage({ key: 'language', value: lang }, false);
    this.sharedService.setUserLanguage(lang);
    this.sharedService.setAppConfig();
    this.reloadCurrentRoute();
  }
  reloadCurrentRoute() {
    const currentUrl = this.router.url; this.router.navigateByUrl(ROUTES.resolver, { skipLocationChange: true }).then(() => { this.router.navigate([currentUrl]); });
  }
  openTermUseModal() {
    this.termUseModalComp.open();
  }

  openPrivacyPoliciesModal() {
    this.privacyPolicyModalComp.open();
  }
  activesection: string | null = null;
  innerlink = true;

  onclick(section: string) {
    this.activesection = this.activesection === section ? null : section;
    this.innerlink = true;
    console.log(this.innerlink, 'inner link');
    console.log(this.activesection, 'active section');
  }
  formembership(section: string) {
    this.activesection = this.activesection === section ? null : section;
    this.innerlink = true;
  }

  closeimg(event: any) {
    event.stopPropagation();
    this.activesection = null;
    this.innerlink = true;
    console.log(this.activesection, 'active section null');
    console.log(this.innerlink, 'inner link true');
  }


}
